module.exports = __webpack_public_path__ + "img/opencollective.5f55b854.svg";